import React from 'react'
import Avatar from '@mui/material/Avatar';
import { deepOrange } from '@mui/material/colors';


const Notes = () => {
	return (
		<div className="notesubcontainer">
			<div className='noteNavigationcontainer'>
				<div className='notecontainer' style={{ marginTop: "20px" }}>
					<div className='notemsgcontainer'>
						<div className='noteinitial'>
							<Avatar sx={{ bgcolor: deepOrange[500], padding: "30px" }}>SM</Avatar>
						</div>
						<div className='noteinput'>
							<input></input>
						</div>
					</div>
					<div className='notesubmit'>
						<div className='empty'></div>
						<button>Post</button>
					</div>

				</div>


			</div>
		</div>
	)
}

export default Notes